
// import React, { useState, useEffect } from "react";
// import {
//     Container,
//     Row,
//     Col,
//     Card,
//     Table,
//     Button
// } from "react-bootstrap";
// import { getDocs, deleteDoc, doc, collection } from "firebase/firestore";
// import { fireDB } from "../../firebase/FirebaseConfig";
// import { Link, useNavigate } from "react-router-dom";

// // ✅ Import AddTour component
// import AddTour from "./AddTour";

// const AdminDashboard = () => {
//     const [tours, setTours] = useState([]);
//     const [showAddForm, setShowAddForm] = useState(false);
//     const navigate = useNavigate();

//     const getAllTours = async () => {
//         try {
//             const snapshot = await getDocs(collection(fireDB, "tours"));
//             const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//             setTours(data);
//         } catch (error) {
//             console.error("Error fetching tours:", error);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm("Are you sure you want to delete this tour?")) {
//             try {
//                 await deleteDoc(doc(fireDB, "tours", id));
//                 getAllTours();
//             } catch (err) {
//                 console.error("Error deleting tour:", err);
//                 alert("❌ Delete failed.");
//             }
//         }
//     };

//     const handleEdit = (id) => {
//         navigate(`/admin/edit-tour/${id}`);
//     };

//     useEffect(() => {
//         getAllTours();
//     }, []);

//     return (
//         <section className="py-5">
//             <Container>
//                 <Row className="mb-4">
//                     <Col className="d-flex justify-content-between align-items-center">
//                         <h4>Admin Dashboard</h4>
//                         <Button variant="success" onClick={() => setShowAddForm(!showAddForm)}>
//                             {showAddForm ? "Close Add Tour" : "Add Tour"}
//                         </Button>
//                         <Link to="/admin/add-blog">
//                             <button>Add Blog</button>
//                         </Link>
//                     </Col>
//                 </Row>

//                 {/* ✅ Toggle AddTour component */}
//                 {showAddForm && <AddTour onSuccess={getAllTours} />}

//                 {/* ✅ All Tours Table */}
//                 <Row>
//                     <Col>
//                         <Card className="p-3 shadow">
//                             <h4 className="mb-3">All Tours</h4>
//                             {tours.length === 0 ? (
//                                 <p>No tours available.</p>
//                             ) : (
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover>
//                                         <thead>
//                                             <tr>
//                                                 <th>Image</th>
//                                                 <th>Location</th>
//                                                 <th>Description</th>
//                                                 <th>Date</th>
//                                                 <th>Action</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {tours.map((tour) => (
//                                                 <tr key={tour.id}>
//                                                     <td>
//                                                         <img
//                                                             src={tour.imageUrl || "https://via.placeholder.com/80x60"}
//                                                             alt={tour.location}
//                                                             width="80"
//                                                             height="60"
//                                                         />
//                                                     </td>
//                                                     <td>{tour.location}</td>
//                                                     <td>{tour.description?.slice(0, 50)}...</td>
//                                                     <td>{tour.date || "N/A"}</td>
//                                                     <td>
//                                                         <Button
//                                                             variant="primary"
//                                                             size="sm"
//                                                             className="me-2"
//                                                             onClick={() => handleEdit(tour.id)}
//                                                         >
//                                                             Edit
//                                                         </Button>
//                                                         <Button
//                                                             variant="danger"
//                                                             size="sm"
//                                                             onClick={() => handleDelete(tour.id)}
//                                                         >
//                                                             Delete
//                                                         </Button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </Table>
//                                 </div>
//                             )}
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>
//         </section>
//     );
// };

// export default AdminDashboard;
import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Table,
    Button
} from "react-bootstrap";
import { getDocs, deleteDoc, doc, collection } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import { Link, useNavigate } from "react-router-dom";

// Import AddTour component
import AddTour from "./AddTour";

const AdminDashboard = () => {
    const [tours, setTours] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [showAddForm, setShowAddForm] = useState(false);
    const navigate = useNavigate();

    // ====================== GET TOURS ======================
    const getAllTours = async () => {
        try {
            const snapshot = await getDocs(collection(fireDB, "tours"));
            const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setTours(data);
        } catch (error) {
            console.error("Error fetching tours:", error);
        }
    };

    // ====================== GET BLOGS ======================
    const getAllBlogs = async () => {
        try {
            const snapshot = await getDocs(collection(fireDB, "blogs"));
            const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setBlogs(data);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        }
    };

    // ====================== DELETE TOUR ======================
    const handleDeleteTour = async (id) => {
        if (window.confirm("Are you sure you want to delete this tour?")) {
            try {
                await deleteDoc(doc(fireDB, "tours", id));
                getAllTours();
            } catch (err) {
                console.error("Error deleting tour:", err);
                alert("❌ Delete failed.");
            }
        }
    };

    // ====================== DELETE BLOG ======================
    const handleDeleteBlog = async (id) => {
        if (window.confirm("Are you sure you want to delete this blog?")) {
            try {
                await deleteDoc(doc(fireDB, "blogs", id));
                getAllBlogs();
            } catch (err) {
                console.error("Error deleting blog:", err);
                alert("❌ Blog delete failed.");
            }
        }
    };

    const handleEditTour = (id) => {
        navigate(`/admin/edit-tour/${id}`);
    };

    const handleEditBlog = (id) => {
        navigate(`/admin/edit-blog/${id}`);
    };

    useEffect(() => {
        getAllTours();
        getAllBlogs();
    }, []);

    return (
        <section className="py-5">
            <Container>
                <Row className="mb-4">
                    <Col className="d-flex justify-content-between align-items-center">
                        <h4>Admin Dashboard</h4>

                        <div className="d-flex gap-3">
                            <Button variant="success" onClick={() => setShowAddForm(!showAddForm)}>
                                {showAddForm ? "Close Add Tour" : "Add Tour"}
                            </Button>

                            <Link to="/admin/add-blog">
                                <Button variant="primary">Add Blog</Button>
                            </Link>
                        </div>
                    </Col>
                </Row>

                {/* Add Tour Toggle */}
                {showAddForm && <AddTour onSuccess={getAllTours} />}

                {/* ====================== TOURS TABLE ====================== */}
                <Row className="mb-5">
                    <Col>
                        <Card className="p-3 shadow">
                            <h4 className="mb-3">All Tours</h4>

                            {tours.length === 0 ? (
                                <p>No tours available.</p>
                            ) : (
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Image</th>
                                                <th>Location</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tours.map((tour) => (
                                                <tr key={tour.id}>
                                                    <td>
                                                        <img
                                                            src={tour.imageUrl || "https://via.placeholder.com/80x60"}
                                                            alt={tour.location}
                                                            width="80"
                                                            height="60"
                                                        />
                                                    </td>
                                                    <td>{tour.location}</td>
                                                    <td>{tour.description?.slice(0, 50)}...</td>
                                                    <td>{tour.date || "N/A"}</td>
                                                    <td>
                                                        <Button
                                                            variant="primary"
                                                            size="sm"
                                                            className="me-2"
                                                            onClick={() => handleEditTour(tour.id)}
                                                        >
                                                            Edit
                                                        </Button>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteTour(tour.id)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>

                {/* ====================== BLOGS TABLE ====================== */}
                <Row>
                    <Col>
                        <Card className="p-3 shadow">
                            <h4 className="mb-3">All Blogs</h4>

                            {blogs.length === 0 ? (
                                <p>No blogs available.</p>
                            ) : (
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Thumbnail</th>
                                                <th>Title</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {blogs.map((blog) => (
                                                <tr key={blog.id}>
                                                    <td>
                                                        <img
                                                            src={blog.thumbnail}
                                                            width="80"
                                                            height="60"
                                                            alt={blog.title}
                                                            style={{ objectFit: "cover" }}
                                                        />
                                                    </td>
                                                    <td>{blog.title}</td>
                                                    <td>{blog.shortDesc?.slice(0, 50)}...</td>
                                                    <td>
                                                        {blog.date
                                                            ? blog.date.toDate().toLocaleDateString()
                                                            : "N/A"}
                                                    </td>

                                                    <td>
                                                        <Button
                                                            variant="primary"
                                                            size="sm"
                                                            className="me-2"
                                                            onClick={() => handleEditBlog(blog.id)}
                                                        >
                                                            Edit
                                                        </Button>

                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteBlog(blog.id)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AdminDashboard;
